import React from 'react';
import styles from './ProductPopUp.module.css';
import {
    InformationCircleIcon,
    CurrencyDollarIcon,
    CheckIcon
} from '@heroicons/react/24/solid';
interface ChatBotPopUpProps {
    onClose: () => void;
}

//챗봇 팝업
const ProductPopUp: React.FC<ChatBotPopUpProps> = ({onClose}) => {

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.popup} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.buttonContainer}>
                        {/*닫기 버튼*/}
                        <button onClick={onClose} className={styles.closeButton}>
                            ×
                        </button>
                    </div>
                    <div className={styles.title}>
                        <span className={styles.titleText}>상품</span>
                    </div>
                </div>
                <div className={styles.content}>
                    <div className={styles.contentBox}>
                        <h3 className={styles.contentTitle}>월 ￦2,800,000 (1인)</h3>
                        <p className={styles.contentSubtitle}>PMS 플랫폼 + 라벨러 교육&관리 + 라벨링&검수</p>
                        <p className={styles.contentText}>
                            <CheckIcon className={styles.checkIcon}/>
                            장기적인 데이터 관리가 필요한 경우
                        </p>
                        <p className={styles.contentText}>
                            <CheckIcon className={styles.checkIcon}/>
                            다양한 작업을 요청하고 싶은 경우
                        </p>
                        <p className={styles.contentText}>
                            <CheckIcon className={styles.checkIcon}/>
                            여러 종류의 데이터 처리 가능
                        </p>
                        <p className={styles.contentText}>
                            <CheckIcon className={styles.checkIcon}/>
                            대량의 데이터 처리 가능
                        </p>
                        <p className={styles.contentSubInfo}>
                            “ 원하는 기간동안 합리적인 가격으로<br/>
                            데이터 서비스를 이용해보세요! ”
                        </p>
                        <p className={styles.contentInfo}>
                            AI 데이터 전문가의 집중 관리를 통해<br/>
                            코드비전이 사업파트너로서 함께합니다.
                        </p>
                    </div>
                    <div className={styles.contentBox}>
                        <h3 className={styles.contentTitle}>서비스 제공기간: 1개월 (30일)</h3>
                        <p className={styles.contentSub}>
                            <InformationCircleIcon className={styles.contentIcon}/>
                            솔루션
                        </p>
                        <p className={styles.contentText}>AI 학습용 데이터셋 구축에 필요한 과정을<br/>
                            대신 수행해드리는 아웃소싱 솔루션입니다.</p>
                        <p className={styles.contentTextEX}>(라벨러 채용/교육/관리, 데이터 라벨링/검수 등)</p>
                        <p className={styles.contentSub}>
                            <CurrencyDollarIcon className={styles.contentIcon}/>
                            구독제
                        </p>
                        <p className={styles.contentText}>월별 정기 구독제로, 필요한 인력의<br/>
                            인건비에 기반해 최종 비용이 산정됩니다.</p>
                        <p className={styles.contentTextEX}>(e.g. 2인: 월 5,600,000원)</p>
                        <p className={styles.contentWarning}>
                            고객사에서 요청하시는 데이터의 양, 작업난이도 등에 따라<br/>
                            필요 인원수 및 소요 기간이 상이할 수 있습니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProductPopUp;